<template>
    <section class="faq">
        <div class="container">
            <div class="layout wrap justify-center h-100">
                <div class="flex xs12 sm12 md12 lg10 xl0">
                    <BackButton
                            defaultRoute="/members/dashboard"
                    />
                    <div class="faq__top">
                        <h4 class="faq__top-title title-h4 text-center">
                            {{$t('members.faq.instructions__title')}}
                        </h4>
                        <div class="faq__top-content text-center font-reg">
                            <span v-html="$t('members.dashboard.info')"></span>
                        </div>
                    </div>

                    <div class="faq__body">
                        <h4 class="title-h4 text-center">
                            {{$t('members.faq.guess_title')}}
                        </h4>
                        <transition-group tag="ul" class="faq__list" name="fade">
                            <li class="faq__item"
                                 v-for="item in faq"
                                 :key="item.question"
                            >
                                <h2 class="faq__item-title font-semi" v-html="item.question"></h2>
                                <div class="faq__item-text font-reg" v-html="item.answer"></div>

                            </li>

                        </transition-group>

                    </div>

                    <div class="faq__footer">
                        <partners/>
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>


<script>
    import {getFaqPage} from '@/api/clientServices'
    import partners from '@/components/members/Partners'

    export default {
        data() {
            return {
                faq: [],
            }
        },
        components: {
            partners
        },
        methods: {
          async getFaq() {
              try {
                let data = await getFaqPage()
                  if(data && data.status === 200) {
                    this.faq = data.data.data.faqs
                  }
              } catch(e) {
                  console.log(e, 'e hello world')
              }
          }
        },
        async mounted() {
            await this.getFaq()
        }
    }
</script>
<style lang="sass" scoped>
    .faq
        color: $color--dark
        &__top
            border-bottom: 1px solid rgba($color--dark, 0.1)
            margin: 16px 0
            &-content
                padding: 16px 0
                font-size: 14px
                color: $color--dark-lighten
        &__body
            min-height: 200px
        &__list
            list-style-type: none
            padding-left: 0
        &__item
            border-bottom: 1px solid rgba($color--dark, 0.1)
            padding: 16px 0
            &-title
                font-size: 18px
                line-height: 1
                +xs
                    font-size: 16px
            &-text
                margin-top: 12px
                color: $color--dark-lighten
                font-size: 16px
                letter-spacing: 0.005em
                line-height: 22px
                +xs
                    font-size: 14px
                b
                    +semi
                p
                    margin: 0!important
                    padding: 0!important
    .fade-enter-active
        transition: all .3s ease
    .fade-leave-active
        transition: all .3s ease
    .fade-enter, .fade-leave-to
        opacity: 0
        transform: translateY(-20px)
</style>